import React, { useState } from "react";
import MainAccountView from "./MainAccountView/MainAccountView";
import SubAccountView from "./SubAccountView/SubAccountView";
import InvitationView from "./InvitationView/InvitationView";
import { useSelector } from "react-redux";
import "./networkContainer.scss";
import { INVITATION, NO_GROUP, HAS_GROUP } from "../../global/utils/constants";
import CreateGroupView from "./CreateGroupView/CreateGroupView";

function NetworkContainer(props) {
  const currentUser = useSelector((state) => state.appReducer.userDataReducer.data);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [email, setEmail] = useState("");

  const determineDisplay = () => {
    const { Group } = currentUser;

    if (!!Group.Invitations?.length) {
      return true;
    }
    return false;
  }

  const determineView = () => {
    const { Group } = currentUser;
    const invitations = currentUser?.Invitations ?? [];

    if (!!invitations.length && !Group?.id) {
      return INVITATION;
    } else if (!!Group?.id) {
      return HAS_GROUP;
    }
    return NO_GROUP;
  }
  const { GroupRole, Group } = currentUser;
  const view = determineView();
  return (
      <>
        {view === NO_GROUP && <CreateGroupView />}
        <div className="network-content-container">
          {view === INVITATION && (
            <div className="content-container">
              <InvitationView />
            </div>
          )}
          {view === HAS_GROUP && (
            <div className="usa-table-wrapper customTableStyle">
              {GroupRole === "Subaccount" ? (
                <SubAccountView
                  type={props.type}
                  myGroup={Group}
                  currentUser={currentUser}
                />
              ) : (
                <MainAccountView type={props.type} />
              )}
            </div>
          )}
        </div>
      </>
    );
  };
export default NetworkContainer;
